import { createReducer } from "@/utils/misc";
import {
  FETCH_PRODUCTS,
  FETCH_ALERTS,
  ADD_ALERT,
  DELETE_ALERT
} from '@/constants';

const initialState = {
  products: [],
  alerts: [],
};

export default createReducer(initialState, {
  [FETCH_PRODUCTS]: (state, payload) => {
    return {
      ...state,
      products: payload,
    };
  },

  [FETCH_ALERTS]: (state, payload) => {
    return {
      ...state,
      alerts: payload,
    };
  },

  [ADD_ALERT]: (state, payload) => {
    return {
      ...state,
      alerts: [...state.alerts, payload]
    }
  },

  [DELETE_ALERT]: (state, payload) => {
    return {
      ...state,
      alerts: state.alerts.filter(alert => alert.id !== payload)
    }
  }
});
